<template lang="html">
  <div class="login-form login-container">
    <transition name="fade-fast" mode="out-in">
      <div v-if="action === 'success'" id="login" class="feedback"
           :style="feedbackStyle">
        <div class="message" :style="messageStyle">Success! The page should reload
          with you logged in. If it takes too long, click the button to
          reload.</div>
        <b-btn variant="primary" @click="reload"
               class="mid-button">reload</b-btn>
        <!-- <b-btn type="submit" variant="success" name="wp-submit" -->
        <!--        class="register-button" value="Register" -->
        <!--        @click="actionRegister">sign-up</b-btn> -->
      </div>
      <div v-else-if="action === 'success-email'" id="login" class="feedback"
           :style="feedbackStyle">
        <div class="message" :style="messageStyle">Success! Please check your mail
          and follow the confirmation link to complete registration</div>
        <div class="login-actions">
          <b-btn variant="primary" @click="reload" class="mid-button">OK</b-btn>
        </div>
      </div>
      <div v-else-if="action === 'link-sent'" id="login" class="feedback"
           :style="feedbackStyle">
        <div class="message" :style="messageStyle">Your login link has been sent.
          This page should reload once you've been logged in. If not, click the
          button to reload</div>
        <div class="login-actions">
          <b-btn variant="primary" @click="reload" class="mid-button">reload</b-btn>
        </div>
      </div>
      <div v-else-if="action === 'not-registered'" id="login" class="feedback"
           :style="feedbackStyle">
        <div class="message" :style="messageStyle">The username <strong>{{
            formData.login }}</strong> is not registered. Would you like to sign
          up?</div>
        <div class="login-actions">
          <b-btn variant="link" @click="goBack"
                 class="login-button">go back</b-btn>
          <b-btn variant="success" @click="register"
                 class="register-button">sign-up</b-btn>
        </div>
      </div>
      <div v-else-if="action === 'email-exists'" id="login" class="feedback"
           :style="feedbackStyle">
        <template v-if="formData.token">
          <div class="message" :style="messageStyle">The email
            <strong>{{ formData.email }}</strong> is already registered. If this
            email is correct, click confirm to get your login link, or go back to
            change it</div>
          <div class="login-actions">
            <b-btn variant="link" @click="goBack"
                   class="login-button">go back</b-btn>
            <b-btn variant="success" @click="confirm"
                   class="register-button">confirm</b-btn>
          </div>
        </template>
        <template v-else>
          <div class="message" :style="messageStyle">The email
            <strong>{{ formData.email }}</strong> is already registered but does
            not match the password given. If this email is correct, click login to
            try again, or click forgot password and a login link will be sent to
            you.</div>
          <div class="login-actions">
            <b-btn variant="link" @click="goToLogin"
                   class="login-button">login</b-btn>
            <b-btn variant="success" @click="confirm"
                   class="register-button">forgot password</b-btn>
          </div>
        </template>
      </div>
      <b-form v-else-if="action === 'unknown-user'" @submit="login"
              id="login" ref="formData"
              @click="formClick"
              :class="[ 'login', action ]">
        <b-alert show variant="warning">We're sorry, we don't have that username
          on record. Please check and re-enter the username or use your email
          address. Hit sign-up to create a new account.</b-alert>
        <b-form-group id="login-username"
                      label="email address"
                      label-for="username">
          <b-form-input id="username" ref="firstInput"
                        type="text"
                        v-model="formData.login"
                        @change="changed"
                        required />
        </b-form-group>
        <b-form-group class="login-actions">
          <b-btn type="submit" variant="primary"
                 name="wp-submit" class="login-button" value="Log in"
                 @click="actionLogin">try again</b-btn>
          <b-btn type="submit" variant="success" name="wp-submit"
                 class="register-button" value="Register"
                 @click="actionRegister">sign-up</b-btn>
        </b-form-group>
      </b-form>
      <b-form v-else-if="action === 'unknown-email'" @submit="login"
              id="login" ref="formData"
              @click="formClick"
              :class="[ 'login', action ]">
        <b-alert show variant="warning">We're sorry, we have no record of that
          email address. If you entered the email incorrectly you can re-enter it
          below to retry. or hit sign-up to create an account</b-alert>
        <b-form-group id="login-email"
                      label="email address"
                      label-for="email">
          <b-form-input id="email" ref="firstInput"
                        type="email"
                        v-model="formData.email"
                        @change="changed"
                        required />
        </b-form-group>
        <b-form-group class="login-actions">
          <b-btn type="submit" variant="primary"
                 name="wp-submit" class="login-button" value="Log in"
                 @click="actionLogin">try again</b-btn>
          <b-btn type="submit" variant="success" name="wp-submit"
                 class="register-button" value="Register"
                 @click="actionRegister">sign-up</b-btn>
        </b-form-group>
      </b-form>
      <b-form v-else @submit="login"
              id="login" ref="formData"
              @click="formClick"
              :class="[ 'login', action ]">
        <transition name="fade-fast">
          <b-form-group v-if="errors.length">
            <b-alert v-for="( error, index ) in errors" variant="danger" show
                     :key="index" v-html="error" />
          </b-form-group>
        </transition>
        <b-form-group id="login-username"
                      :label="action === 'register' ? 'username'
                              : 'username or email address'"
                      label-for="username">
          <b-form-input id="username" ref="firstInput"
                        type="text"
                        v-model="formData.login"
                        @change="changed"
                        required />
        </b-form-group>
        <transition name="fade-fast">
          <b-form-group v-if="action === 'register'"
                        id="login-email"
                        label="email address"
                        label-for="email">
            <b-form-input id="email"
                          type="email"
                          v-model="formData.email"
                          @change="changed"
                          required />
          </b-form-group>
        </transition>
        <transition name="fade-fast" mode="out-in">
          <div id="login-password" v-if="tokenLogin">
            <template v-if="action === 'register'">
              <b-alert show>A password will be generated
                for you and sent with your confirmation email.</b-alert>
              <b-btn variant="link" @click="enterPass">set password now</b-btn>
            </template>
            <template v-else>
              <b-alert show>An email will be sent with a link that will log
                you in when you click it. This link will expire in 10
                minutes.</b-alert>
              <b-btn v-if="passwordWrong" variant="link"
                     @click="enterPass">try enter password again</b-btn>
              <b-btn v-else variant="link"
                     @click="enterPass">enter password instead</b-btn>
            </template>
          </div>
          <b-form-group v-else-if="action === 'register'"
                        id="login-password">
            <b-form-group id="login-password1"
                          label="password"
                          label-for="password1">
              <b-form-input id="password1"
                            type="password"
                            v-model="formData.pass"
                            @change="changed"
                            required />
            </b-form-group>
            <b-form-group id="login-password2"
                          label="confirm password"
                          label-for="password2">
              <b-form-input id="password2"
                            type="password"
                            v-model="confirmPass"
                            @change="changed"
                            required />
            </b-form-group>
            <b-btn variant="link" @click="sendLink">don't set password now</b-btn>
          </b-form-group>
          <b-form-group v-else
                        id="login-password"
                        label="password"
                        label-for="password">
            <b-form-input id="password"
                          type="password"
                          v-model="formData.pass"
                          @change="changed"
                          required />
            <b-btn v-if="passwordWrong" variant="link"
                   @click="sendLink">forgot password</b-btn>
            <b-btn v-else variant="link"
                   @click="sendLink">email login link instead</b-btn>
          </b-form-group>
        </transition>
        <transition name="fade">
          <b-form-group v-if="recaptcha.show || !recaptcha.response"
                        id="login-recaptcha">
            <vue-recaptcha :sitekey="recaptcha.key"
                           @rendered="recaptchaShow"
                           @verify="recaptchaSuccess"
                           @expired="recaptchaExpired"
                           theme="dark" />
          </b-form-group>
        </transition>
        <b-form-group class="login-actions">
          <b-btn v-if="action != 'register'" type="submit" variant="primary"
                 name="wp-submit" class="login-button" value="Log in"
                 @click="actionLogin">{{ tokenLogin ? 'send link' : 'login'
            }}</b-btn>
          <b-btn v-else variant="link" @click="clearForm"
                 class="login-button">cancel</b-btn>
          <span v-if="action != 'register'">or</span>
          <b-btn type="submit" variant="success" name="wp-submit"
                 class="register-button" value="Register"
                 @click="actionRegister">sign-up</b-btn>
        </b-form-group>
      </b-form>
    </transition>
  </div>
</template>

<script lang="js">
import he from 'he'
import qs from 'qs'
import axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'
import { User } from '@/mixins'

export default {
  name: 'login-form',
  mixins: [ User ],
  components: { VueRecaptcha },
  props: {
    shown: {
      type: Boolean,
      default: true
    },
    redirect: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      action: 'login',
      userExists: false,
      recaptcha: {
        key: this.$store.state.recaptcha_key,
        response: null,
        show: false
      },
      errors: [],
      usernameTaken: false,
      passwordWrong: false,
      emailTaken: false,
      feedbackStyle: {
        minHeight: '',
        minWidth: ''
      },
      messageStyle: {
        minHeight: ''
      },
      formData: {
        action: 'achlogin',
        login: '',
        email: '',
        pass: '',
        redirect_url: '',
        remember: true,
        'g-recaptcha-response': '',
        token: false,
        sec_token: this.$store.state.ajax.sec
      },
      confirmUser: '',
      confirmPass: '',
      tokenLogin: false,
      ajaxUrl: this.$store.state.ajax.url
    }
  },
  created() {},
  mounted() {
    this.formData.redirect_url = this.redirect
  },
  methods: {
    login(e) {
      e.preventDefault()
      if ( this.action !== 'register' && this.formData.action === 'achregister' ) {
        this.action = 'register'
        this.errors = []
        if ( /.+@.+\..+/.test( this.formData.login )) {
          this.formData.email = this.formData.login
          this.formData.login = ''
        }
        return false
      }
      if ( !this.recaptcha.response ) {
        this.errors.push( 'captcha: are you a robot?' )
        return false
      }
      this.usernameTaken = false
      this.passwordWrong = false
      this.formData['g-recaptcha-response'] = this.recaptcha.response
      this.formData.token = this.tokenLogin
      axios.post( this.ajaxUrl, qs.stringify( this.formData ), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencodedcharset=utf-8'
        }
      }).then( response => {
        var d = response.data
        console.log( 'formData response', d )
        switch ( d.next ) {
        case 'wrong-password':
          this.action = 'login'
          this.errors.push( 'the password you entered was incorrect' )
          this.passwordWrong = true
          break
        case 'unknown-user':
        case 'unknown-email':
        case 'email-exists':
        case 'success-email':
        case 'not-registered':
          var $el = this.$refs.formData
          this.feedbackStyle.minHeight = $el.clientHeight + 'px'
          this.messageStyle.minHeight = $el.clientHeight - 60 + 'px'
          this.feedbackStyle.minWidth = $el.clientWidth + 'px'
          this.action = d.next
          this.$nextTick(() => {
            if ( !this.formData.email ) {
              this.action = 'login'
            }
          })
          break
        case 'link-sent':
          this.action = 'link-sent'
          this.waitLogin()
          // TODO: close form
          break
        case 'user-exists':
          this.usernameTaken = true
          break
        case 'forgot-password':
          break
        case 'error':
          break
        case 'success':
          // success!
          this.action = 'success'
          this.reload()
        }
      }).catch( error => {
        console.warn( 'server error', error )
        this.action = 'system-error'
        // Swal( "We're sorry! There was some problem. Please try again later" )
      })
      return false
    },
    waitLogin() {
    },
    sendLink() {
      this.tokenLogin = true
    },
    enterPass() {
      this.tokenLogin = false
    },
    recaptchaShow() {
      this.recaptcha.response = ''
      this.recaptcha.show = true
    },
    recaptchaSuccess( response ) {
      this.errors = this.errors.filter( x => !/captcha/.test(x) )
      this.recaptcha.response = response
      window.setTimeout( () => { this.recaptcha.show = false }, 2000 )
      window.setTimeout( () => { this.recaptcha.response = '' }, 100000 )
    },
    recaptchaExpired() {
      this.recaptcha.response = ''
    },
    actionLogin() {
      this.formData.action = 'achlogin'
    },
    actionRegister() {
      this.formData.action = 'achregister'
      if ( this.action !== 'register') {
        this.action = 'register'
        this.errors = []
        if ( /.+@.+\..+/.test( this.formData.login )) {
          this.formData.email = this.formData.login
          this.formData.login = ''
        }
      }
    },
    showFormRegister() {
      this.action = 'register'
    },
    showFormLogin() {
      this.action = 'login'
    },
    showFormUser() {
      this.action = 'unknown-user'
    },
    showFormEmail() {
      this.action = 'unknown-email'
    },
    formClick(e) {
      console.log( 'formClick', e )
      e.stopPropagation()
    },
    changed(e) {
      this.$emit('change', { orig: e })
    },
    clearForm() {
      this.formData = {
        action: 'achlogin',
        login: '',
        email: '',
        pass: '',
        remember: true,
        'g-recaptcha-response': '',
        token: false,
        sec_token: this.$store.state.ajax.sec
      }
      this.action = 'login'
      this.confirmUser = ''
      this.confirmPass = ''
      this.tokenLogin = false
    },
    reload() {
      window.location.reload()
    },
    goBack(e) {
      e.stopPropagation()
      if ( this.action === 'not-registered' ) {
        this.action = 'login'
      } else {
        this.action = 'register'
      }
    },
    goToLogin(e) {
      e.stopPropagation()
      this.formData.login = this.formData.email
      this.formData.email = ''
      this.action = 'login'
    },
    confirm(e) {
      this.formData.action = 'achlogin'
      this.formData.token = true
      this.login(e)
    },
    register(e) {
      e.stopPropagation()
      this.action = 'login'
      this.formData.action = 'achregister'
      this.login(e)
    },
    focusFirst() {
      window.setTimeout(() => {
        if ( this.$refs.firstInput ) {
          this.$refs.firstInput.focus()
        }
      }, 150 )
    }
  },
  computed: {
    loggedIn() {
      return this.user && this.user.id
    },
    logoutLink() {
      return he.decode( this.user.logout )
    }
  },
  watch: {
    action( newVal, oldVal ) {
      if ( newVal !== oldVal ) {
        this.focusFirst()
      }
    },
    shown( val ) {
      if ( val ) this.focusFirst()
    }
  }
}
</script>

<style lang="scss">
.login-form {

}
</style>
